'use client';

import React from 'react';

interface ClockActionButtonProps {
  status: 'clocked_in' | 'clocked_out';
  isLoading: boolean;
  onAction: () => void;
}

export default function ClockActionButton({
  status,
  isLoading,
  onAction,
}: ClockActionButtonProps) {
  const isClockedIn = status === 'clocked_in';

  return (
    <div className="flex flex-col gap-3">
      <button
        onClick={onAction}
        disabled={isLoading}
        className={`w-full py-5 rounded-2xl font-bold text-xl text-white flex items-center justify-center gap-3 transition-all duration-150 active:scale-95 disabled:opacity-70 disabled:cursor-not-allowed ${
          isClockedIn ? 'btn-clock-out' : 'btn-clock-in'
        }`}
      >
        {isLoading ? (
          <>
            <div className="w-6 h-6 border-3 border-white border-t-transparent rounded-full animate-spin" style={{ borderWidth: '3px' }} />
            <span>Recording...</span>
          </>
        ) : (
          <>
            {isClockedIn ? (
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
                <circle cx="12" cy="12" r="10"/>
                <rect x="9" y="9" width="6" height="6"/>
              </svg>
            ) : (
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
                <circle cx="12" cy="12" r="10"/>
                <polyline points="12 6 12 12 16 14"/>
              </svg>
            )}
            <span>{isClockedIn ? 'CLOCK OUT' : 'CLOCK IN'}</span>
          </>
        )}
      </button>

      <p className="text-xs text-center text-muted-foreground">
        Official time is recorded by the server — your phone clock has no effect
      </p>
    </div>
  );
}